import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import ApiRequest from "../helper/ApiRequest";
import { BaseUrl } from "../helper/BaseUrl";
import Breadcrumb from "../../component/Breadcrumb";

const blogListEndpoint = ApiEndpoints.blogs.blogDetail;

export default function BlogDetailInfo() {

  const [data, setData] = useState(null);
  const { blog_slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // fetch blog data 
  const fetchData = useCallback(
    async (slug) => {
      try {
        setLoading(true)
        const response = await ApiRequest("GET", `${blogListEndpoint}${slug}`);
        const result = response.blog;
        if (result) {
          setData(result);
        }else{
          navigate("/404", { replace: true });
        }
      } catch (error) {
        navigate("/404", { replace: true });
      } finally{
        setLoading(false)
      }
    },
    [navigate]
  );

  useEffect(() => {
    fetchData(blog_slug);
  }, [blog_slug, fetchData]);

  // Format Date
  const formattedDate = useMemo(() => {
    if (data?.createdAt) {
      const date = new Date(data.createdAt);
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    }
    return null;
  }, [data?.createdAt]);

  // sanatizing html with memo
  const sanitizedHtml = useMemo(
    () => (data?.description ? DOMPurify.sanitize(data.description) : ""),
    [data?.description]
  );

  if (loading) {
    return <div style={{ width:"100%",height:"100vh" }}></div>;
  }

  const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"blogs",
      slug:"/blog"
    },
    {
      page: data?.name?.slice(0,12) +"...",
      slug:`/blog/${data?.slug}`
    },
  ]
}

  return (
    <section className="blog-detail-area header-gap">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Breadcrumb breadcrumbData={breadcrumbData}/>
            <div className="header-detail-place">
              <h1 className="heading">{data?.name}</h1>
              <div className="detail-date-owner">
                <div className="detail-owner-box">
                  <img className="img-responsive" src="../assets/home/blogdetail-owner.webp" alt="author"
                    loading="lazy" width="50" height="50" />
                  <span>{data?.author_name}</span>
                </div>
                {/* Date Information */}
                <div className="detail-owner-box">
                  <img
                    className="img-responsive"
                    src="../assets/home/blogdetail-date-icon.webp"
                    alt="date"
                    loading="lazy"
                    width="50"
                    height="50"
                  />
                  <span>{formattedDate}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Blog Content */}
          <div className="col-lg-12">
            <img
              className="img-responsive blog-list-img"
              src={`${BaseUrl}${data?.section_image}`}
              alt={data?.alt_section_image || "Blog Image"}
              width="1116"
              height="416"
            />
            <div className="blog-list-content">
              <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
